// src/context/reducers/authReducer.js
import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SET_USER,
} from "../types/authTypes";

const initialState = {
  user: null,
  error: null,
  isLoggedIn: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case SET_USER:
      return {
        ...state,
        user: action.payload,
        isLoggedIn: true,
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoggedIn: false,
      };
    case LOGOUT:
      return {
        ...state,
        user: null,
        isLoggedIn: false,
        error: null,
      };
    default:
      return state;
  }
};

export default authReducer;
